export default "__VITE_ASSET__BADnLw3V__"